export { default as CoreLegend } from './Legend';
